import type { ApiRequestWith } from "@/api/types";
import { getGroupAuthType } from "@/utils/authToken";
import type {
  GoalAndObjectiveTextResponse,
  GoalsAndObjectivesResponse,
  ModalityTextResponse,
  PatientArticulatedGoalsResponse,
  PatientMedicalCautionsResponse,
  PatientStrengthAndCautionOptionsResponse,
  PatientStrengthsResponse,
} from "@/core/types";
import { GROUP_AUTH_HEADER_NAME } from "@/api/constants";
import { httpAuth } from "@/api/httpAuth";

type CarePlanRequestsTyped = {
  get_goal_and_objective_text: ApiRequestWith<
    GoalAndObjectiveTextResponse,
    { urlParams: { patientId: string } }
  >;
  get_goals_and_objectives: ApiRequestWith<
    GoalsAndObjectivesResponse,
    { urlParams: { patientId: string } }
  >;
  get_modality_text: ApiRequestWith<ModalityTextResponse, { urlParams: { patientId: string } }>;
  get_patient_articulated_goals: ApiRequestWith<
    PatientArticulatedGoalsResponse,
    { urlParams: { patientId: string } }
  >;
  get_patient_medical_cautions: ApiRequestWith<
    PatientMedicalCautionsResponse,
    { urlParams: { patientId: string } }
  >;
  get_patient_strength_and_caution_options: ApiRequestWith<
    PatientStrengthAndCautionOptionsResponse,
    { urlParams: { patientId: string } }
  >;
  get_patient_strengths: ApiRequestWith<
    PatientStrengthsResponse,
    { urlParams: { patientId: string } }
  >;
};

export const carePlanRequestsTyped: CarePlanRequestsTyped = {
  get_goal_and_objective_text: function ({ context, urlParams }) {
    return httpAuth
      .post(`/v1/care-plan/${urlParams.patientId}/get_goal_and_objective_text`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<GoalAndObjectiveTextResponse>();
  },

  get_goals_and_objectives: function ({ context, urlParams }) {
    return httpAuth
      .post(`/v1/care-plan/${urlParams.patientId}/get_goals_and_objectives`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<GoalsAndObjectivesResponse>();
  },

  get_modality_text: function ({ context, urlParams }) {
    return httpAuth
      .post(`/v1/care-plan/${urlParams.patientId}/get_modality_text`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<ModalityTextResponse>();
  },

  get_patient_articulated_goals: function ({ context, urlParams }) {
    return httpAuth
      .post(`/v1/care-plan/${urlParams.patientId}/get_patient_articulated_goals`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<PatientArticulatedGoalsResponse>();
  },

  get_patient_medical_cautions: function ({ context, urlParams }) {
    return httpAuth
      .post(`/v1/care-plan/${urlParams.patientId}/get_patient_medical_cautions`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<PatientMedicalCautionsResponse>();
  },

  get_patient_strength_and_caution_options: function ({ context, urlParams }) {
    return httpAuth
      .post(`/v1/care-plan/${urlParams.patientId}/get_patient_strength_and_caution_options`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<PatientStrengthAndCautionOptionsResponse>();
  },

  get_patient_strengths: function ({ context, urlParams }) {
    return httpAuth
      .post(`/v1/care-plan/${urlParams.patientId}/get_patient_strengths`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<PatientStrengthsResponse>();
  },
};
